export default __webpack_public_path__ + "/dist/images/9160506.49c7bcbdb40cccc97befbd2c03bf1b05.png";